import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Copy Rights @ <b>Soft Force</b> 2024
    </span>`,
})
export class FooterComponent {
  year: number = new Date().getFullYear()
}
